// @ts-strict-ignore
import React, { memo } from 'react'
import { Grid, List, ListItemText, ListItemAvatar, ListItemSecondaryAction, ListItemButton } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { browserHistory } from 'services/router'
import Box from 'components/Box'
import Condition from 'components/Condition'
import MoreButtonDialog from 'components/MoreButtonDialog'
import PersonAvatar from 'components/PersonAvatar'
import ShareWidget from 'components/ShareWidget'
import Suspense from 'components/Suspense'
import { formatAsDate } from 'services/formatting'
import { Share } from '@mui/icons-material'
import { useFragment } from 'react-relay/hooks'
import { graphql } from 'relay-runtime'
import { MetaInfo_BlogPostFragment$key } from '__generated__/MetaInfo_BlogPostFragment.graphql'
import { useResponsiveBreakpoint } from 'hooks/useResponsiveBreakpoint'
import useStyles from './styles'

function MetaInfo({ blogPostFragment }: { blogPostFragment: MetaInfo_BlogPostFragment$key }) {
  const { classes } = useStyles()
  const theme = useTheme()
  const isTablet = useResponsiveBreakpoint(theme.breakpoints.values.md)
  const blogPost = useFragment<MetaInfo_BlogPostFragment$key>(graphql`
    fragment MetaInfo_BlogPostFragment on BlogPost {
      status
      updatedAt
      user {
        name
        avatarUrl
        profile {
          slug
        }
      }
    }
  `, blogPostFragment)

  const getPostedByTitle = () => {
    if (blogPost?.status === 'approved' || blogPost?.status === 'published') {
      return `Posted by ${blogPost?.user?.name}`
    }
    return `Draft by ${blogPost?.user?.name}`
  }

  const renderAvatar = (url: string) => {
    return <PersonAvatar url={url} />
  }

  const handleAuthorClick = (e) => {
    e.preventDefault()
    browserHistory.push('/[...slugs]', `/${blogPost.user?.profile?.slug}`)
  }

  return (
    <Box className={classes.container}>
      <Condition condition={isTablet}>
        <List disablePadding>
          <ListItemButton onClick={handleAuthorClick} disableGutters>
            <ListItemAvatar>
              {renderAvatar(blogPost?.user?.avatarUrl)}
            </ListItemAvatar>

            <ListItemText
              primary={getPostedByTitle()}
              secondary={`on ${formatAsDate(blogPost?.updatedAt)}`}
            />

            <Suspense>
              <ListItemSecondaryAction>
                <MoreButtonDialog icon={<Share />} dialogTitle="Share Article...">
                  <ShareWidget />
                </MoreButtonDialog>
              </ListItemSecondaryAction>
            </Suspense>
          </ListItemButton>
        </List>
      </Condition>

      <Condition condition={!isTablet}>
        <Grid container alignItems="center">
          <Grid item xs={12} md={6}>
            <List>
              <ListItemButton onClick={handleAuthorClick}>
                <ListItemAvatar>
                  {renderAvatar(blogPost?.user?.avatarUrl)}
                </ListItemAvatar>

                <ListItemText
                  primary={getPostedByTitle()}
                  secondary={`on ${formatAsDate(blogPost?.updatedAt)}`}
                />
              </ListItemButton>
            </List>
          </Grid>

          <Suspense>
            <Grid item xs={12} md={6}>
              <div className={classes.share}>
                <div className={classes.shareWrapper}>
                  <ShareWidget />
                </div>
              </div>
            </Grid>
          </Suspense>
        </Grid>
      </Condition>
    </Box>
  )
}

export default memo(MetaInfo)
